export function pdfDeliveryLabel(status: string): string {
	return status === 'not_configured' ? '' : ` · ${status}`;
}
